module.exports = __webpack_public_path__ + "static/img/spacecraft-dynamics.c4dbbea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spacecraft-dynamics.jpg
// module id = 4FVx
// module chunks = 0